import { styled, Tabs } from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const StyledTabs = styled(Tabs)(() => ({
  width: '100%',
  '& .MuiTabs-flexContainer': {
    display: 'flex',
    flexWrap: 'wrap',
  },
  '& .MuiTabScrollButton-root': {
    display: 'none',
  },
  '& .MuiTab-root:not(.Mui-selected)': {
    fontSize: pxToRem(20),
    color: '#837300',
  },
  '& .MuiTab-root': {
    fontSize: pxToRem(20),
    color: '#837300',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));
